import { Component, OnInit } from '@angular/core';
import { FeedbackService } from '../../services/feedback.service';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-fbqttypemas',
  templateUrl: './fbqttypemas.component.html',
  styleUrls: ['./fbqttypemas.component.scss'],
  providers:[FeedbackService]
})
export class FbqttypemasComponent implements OnInit {

  



    ddlfeed=[];
    memberdetails:any[]=[];
    classdetails:any[]=[];
    closeResult: string;
    fedopts:any[]=[];
   
    student:boolean=true;
    staff:boolean=false;
    memberdash:any={};
    objfedhead:any={};
    objquesthead:any={};
    objquestopt:any={};
    selfed:any='0';
    
    modalOptions:NgbModalOptions;
    private modalRef: NgbModalRef;
    constructor(private http: HttpClient, private liservice: FeedbackService,private modalService: NgbModal) { }
  
    open(content) {
      this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }
  
    private getDismissReason(reason: any): string {
      if (reason === ModalDismissReasons.ESC) {
        return 'by pressing ESC';
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
        return 'by clicking on a backdrop';
      } else {
        return `with: ${reason}`;
      }
    }
  
  
  
    ngOnInit(): void {
      
     //  this.getmemberdetails('selstu','');
     //  this.getclassdetails();
     //  this.memberdashcnts('dashcnts');
     this.getfedbackhead(0,'selallhead');
    }
  
    getfedbackhead(fbid,oprtype) {
      this.liservice.getfeedbackqttype(fbid,oprtype)
          .subscribe(
          resultArray => {
              console.log('members-result', resultArray);
              if(oprtype=='selallhead')
              {
              this.memberdetails = resultArray;
              }
              else if(oprtype=='seldet')
              {
              this.classdetails = resultArray;
              }
              
              
          },
          error => console.log("Error :: " + error)
          )
    }

    composefilterstaff(jstring)
{
 var newstr = jstring.replace(/fbid/g, "value"); 
 var newstr = newstr.replace(/fbheadnm/g, "label"); 
 console.log('jsonrep',newstr);
 let resJSON = JSON.parse(newstr);
 var arr=Array.of(resJSON);
 
 this.ddlfeed=arr[0];
 console.log('staffs',this.ddlfeed);
}
onChangeclass(val)
{
debugger;
 this.selfed=val;
 this.getfeedbackquestionhead(this.selfed,0,'selbyid');
 //this.getstudentdata('sel_alloted');
}
    
   openquesthead(content,objdata,cmd) {
     if(cmd=='inshead')
     {
       this.objquesthead={};
       this.objquesthead.fbqttypeid='0';
       this.objquesthead.oprtype='inshead';
       this.objquesthead.fbqttypenm='';
       this.objquesthead.fbqtoptionnm=''
 
     }
 
     else if(cmd=='updhead')
     {
       this.objquesthead=objdata;
       this.objquesthead.oprtype='updhead';
     }
     
     this.modalOptions = {
       backdrop:'static',
       backdropClass:'customBackdrop',
       
      
     }
     this.modalRef=this.modalService.open(content,this.modalOptions);
     
     this.modalRef.result.then((result) => {
    
          
       }, (reason) => {
           
       });
   }


   openoprtions(content,fbqtid) {
     
       this.objquestopt={};
       
       this.objquestopt.fbqttypeid=fbqtid;
       //this.objquesthead.oprtype='insert';
       this.objquestopt.fbqtoptionnm='';
       
 
    
     
     this.modalOptions = {
       backdrop:'static',
       backdropClass:'customBackdrop',
     
      
     }
     this.modalRef=this.modalService.open(content,this.modalOptions);
     
     this.modalRef.result.then((result) => {
    
          
       }, (reason) => {
           
       });

       this.getfedbackhead(fbqtid,'seldet');
   }
savefedbackhead()
{
//console.log('catsave',this.genmodel);
 this.liservice.savefedbackhead(this.objfedhead)
     .subscribe(
     result => {
         console.log('SavegenmasDetails', result);
         //this.suppliers = resultArray;
         alert(result.message);
         if(result.status=='Success')
         {
           let localmodref=this.modalRef;
           localmodref.close();
           this.getfedbackhead(0,'selall');

         }
        else
        {

        }
     },
     error =>{ alert('Error While saving...');}
     )
}

savefeedbackquestionhead()
{
//console.log('catsave',this.genmodel);
 this.liservice.savefeedbackqttype(this.objquesthead)
     .subscribe(
     result => {
         console.log('SavegenmasDetails', result);
         //this.suppliers = resultArray;
         alert(result.message);
         if(result.status=='Success')
         {
           let localmodref=this.modalRef;
           localmodref.close();
           this.getfedbackhead(0,'selallhead');

         }
        else
        {

        }
     },
     error =>{ alert('Error While saving...');}
     )
}

savefedoptions()
{
//console.log('catsave',this.genmodel);
this.objquestopt.oprtype='insdet';
this.objquestopt.fbqttypenm='';

 this.liservice.savefeedbackqttype(this.objquestopt)
     .subscribe(
     result => {
         console.log('SavegenmasDetails', result);
         //this.suppliers = resultArray;
         alert(result.message);
         this.objquestopt.fbqtoptionnm='';
         this.getfedbackhead(this.objquestopt.fbqttypeid,'seldet');
       //   if(result.status=='Success')
       //   {
       //     let localmodref=this.modalRef;
       //     localmodref.close();
       //     this.getfeedbackquestionhead(this.selfed,0,'selbyid');

       //   }
       //  else
       //  {

       //  }
     },
     error =>{ alert('Error While saving...');}
     )
}
getfeedbackquestionhead(fbid,fbqtid,oprtype) {
 this.liservice.getfeedbackquestionhead(fbid,fbqtid,oprtype)
     .subscribe(
     resultArray => {
         console.log('members-result', resultArray);
         this.classdetails = resultArray;
         
     },
     error => console.log("Error :: " + error)
     )
}

getfeedbackopts(fbid,fbqtid,oprtype) {
 this.liservice.getfeedbackopts(fbid,fbqtid,oprtype)
     .subscribe(
     resultArray => {
         console.log('options', resultArray);
         this.fedopts = resultArray;
         
     },
     error => console.log("Error :: " + error)
     )
}


delfeedbackopts(fbid) {
 this.liservice.delfeedbackopts(fbid)
 .subscribe(
   result => {
       console.log('SavegenmasDetails', result);
       //this.suppliers = resultArray;
       alert(result.message);
      // this.objquestopt.qtrespnm='';
       this.getfeedbackopts(this.selfed,this.objquestopt.fbqtid,'selbyid');
     //   if(result.status=='Success')
     //   {
     //     let localmodref=this.modalRef;
     //     localmodref.close();
     //     this.getfeedbackquestionhead(this.selfed,0,'selbyid');

     //   }
     //  else
     //  {

     //  }
   },
   error =>{ alert('Error While saving...');}
   )
}
   //  memberdashcnts(oprtype) {
   //    this.liservice.getmemberdetails(oprtype,'')
   //        .subscribe(
   //        resultArray => {
   //            console.log('members-result', resultArray);
   //            this.memberdash = resultArray[0];
              
   //        },
   //        error => console.log("Error :: " + error)
   //        )
   //  }
  
    staffclick()
    {
      
      this.staff=true;
      this.student=false;
      this.getfeedbackquestionhead(this.selfed,0,'selbyid');
    }
    studentclick()
    {
     // alert('student click');
      this.staff=false;
      this.student=true;
      this.getfedbackhead(0,'selall');
    }
  
   //  getclassdetails() {
   //    this.liservice.getclassdetails()
   //        .subscribe(
   //        resultArray => {
              
             
   //            console.log('class-result', resultArray);
   //            var autharr=resultArray;
   //            var farr= Array.from(new Set(autharr.map((item: any) => item.clname)));
   //            var auth=[];
   //          for(var i=0;i<farr.length;i++)
   //            {
   //              debugger
   //              let objval:any={};
   //              objval.label=farr[i]
   //              objval.value=farr[i];
   //              console.log('obj',objval);
   //              auth.push(objval);
   //              objval={};
   //            }
  
   //            this.classdetails = auth;
   //            console.log('class-result', this.classdetails);
  
   //                  },
   //                  error => console.log("Error :: " + error)
   //          )
   //  }
  
  
   
  
  
   
  }
